<template>
  <div class="subpage">
    <div class="header"></div>
    <div class="contact">
      <div class="contant">
        <div class="left">
          <el-menu
            ref="elMenu"
            class="menu"
            :default-active="activeNames"
            @select="select"
          >
            <!-- 递归动态菜单 -->
            <menu-tree :list="list"></menu-tree>
          </el-menu>
        </div>
        <div class="right">
          <div class="title">
            <h2>{{ title }}</h2>
          </div>
          <slot name="left-content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myMixin } from '../../mixin'
import MenuTree from '../../views/MenuTree/MenuTree'

export default {
  name: 'Subpage',
  components: {
    MenuTree
  },
  mixins: [myMixin],
  props: {
    activeNames: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      collapsed: false,
      rootSubmenuKeys: [],
      title: ''
    }
  },
  created() {
    this.subMenuKeysHandle()
  },
  mounted() {
    setTimeout(() => {
      this.initTitle()
    }, 200)
  },
  methods: {
    select(key) {
      const obj = this.findMix(this.list, key)
      this.title = obj.title
      this.$emit('selectItem', key)
    },

    // 是否有子节点
    hasOneChil(item) {
      return !Object.prototype.hasOwnProperty.call(item, 'children')
    },

    // subMenuKeys
    subMenuKeysHandle() {
      const subMenuKeys = []
      this.list.forEach((item) => {
        if (Object.prototype.hasOwnProperty.call(item, 'children')) {
          subMenuKeys.push(item.name)
        }
        item.children.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(key, 'children')) {
            subMenuKeys.push(key.name)
          }
        })
      })
      this.rootSubmenuKeys = subMenuKeys
    },

    // title
    initTitle() {
      const obj = this.findMix(this.list, this.activeNames)
      this.title = obj.title
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 100px;
  background-color: rgb(0, 113, 193);
}

.title {
  height: 45px;
}

.title > h2 {
  font-size: 26px;
  color: #0b0b0b;
  margin: 18px 0;
  border-left: 3px solid #0099d9;
  padding-left: 24px;
}

.menu {
  width: 160px;
  cursor: pointer;
}

.contant {
  display: flex;
}

.contact {
  width: 1200px;
  margin: auto;
  margin-top: 100px;
  margin-bottom: 100px;
}

.left {
  padding: 0 30px;
}

.right {
  width: 100%;
}

.menu-item {
  padding: 10px;
  cursor: pointer;
}

.disabled {
  pointer-events: none;
  color: #cccccc;
}

.menu {
  width: 200px;
}
</style>
